import { ACLS } from "../../constants/acls";
import type { IExecProject } from "../../types/agent-pipelines";
import type { IUser } from "../../types/users";

export const COLLABORATOR_UNSUPPORTED_MESSAGE =
  "Not supported for collaborators.";

export const getRaasProjectCollaboration = ({
  currentUser,
  project,
}: {
  currentUser?: Pick<IUser, "uid" | "account_id" | "roles">;
  project?: Pick<
    IExecProject,
    "created_by_uid" | "account_id" | "collaborators"
  >;
}) => {
  const isOwner = Boolean(
    currentUser?.uid && currentUser.uid === project?.created_by_uid
  );
  const isSameOrg = Boolean(
    currentUser?.account_id && currentUser.account_id === project?.account_id
  );
  const roles = currentUser?.roles ?? [];
  const isAdministrator =
    roles.includes(ACLS.AGENTIC_INTERNAL_ADMIN) ||
    roles.includes(ACLS.ORACLE_ACL) ||
    (isSameOrg &&
      (roles.includes(ACLS.ADMIN_ACL) ||
        roles.includes(ACLS.PLATFORM_ACCOUNT_ADMIN)));
  const canManageCollaborators = Boolean(
    project && ((isOwner && isSameOrg) || isAdministrator)
  );
  const isCollaborator = Boolean(
    !canManageCollaborators &&
      isSameOrg &&
      currentUser?.uid &&
      project?.collaborators?.some((member) => member.uid === currentUser.uid)
  );

  return { isCollaborator, canManageCollaborators };
};
